import { ClothesEmploye } from "./clothesEmployeModel";
import { EmployeModel } from "./employeModel";

export class ResponseInfoDeliverClothesModel {

    employee: EmployeModel;
    totalPrendas: number;
    clothesEmployes: ClothesEmploye[];

    constructor() { }
}